import React from "react";
import { useTranslation } from "react-i18next";
import {
  APP_LANGUAGES,
  applyDocumentLanguage,
  normalizeAppLanguage,
} from "util/locale";
import styles from "./AuthLanguageSwitch.module.scss";

const AuthLanguageSwitch = ({ className }) => {
  const { i18n } = useTranslation();
  const current = normalizeAppLanguage(i18n.language);

  const setLang = (code) => {
    const next = normalizeAppLanguage(code);
    void i18n.changeLanguage(next);
    window.localStorage.setItem("userLang", next);
    applyDocumentLanguage(next);
    try {
      const params = new URLSearchParams(window.location.search);
      params.set("lang", next);
      const nextUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState(null, "", nextUrl);
    } catch {
      // ignore
    }
  };

  return (
    <nav
      className={`${styles.switch} ${className || ""}`.trim()}
      aria-label="Language"
    >
      {APP_LANGUAGES.map(({ code, nativeLabel }) => (
        <button
          key={code}
          type="button"
          className={`${styles.btn} ${
            current === code ? styles.btnActive : ""
          }`}
          aria-pressed={current === code}
          title={nativeLabel}
          onClick={() => setLang(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </nav>
  );
};

export default AuthLanguageSwitch;
